import { formatDate, formatDateLocale } from './dates';

// Stored values are shown in the user's profile timezone, not the browser's — see ./dates.
// `format` is a date-fns format string. For a locale-styled date (the toLocaleDateString
// family) pass `localeStyle` ('date' | 'time' | 'dateTime') and/or Intl `options`, with an
// optional `locale`.
export default function DateDisplay(props){
    const { value, format = 'yyyy-MM-dd', options, locale, localeStyle } = props;
    if(options != null || localeStyle != null)
        return formatDateLocale(value, options, locale, localeStyle);
    return formatDate(value, format);
}
